import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Parallax from "react-rellax";
import * as screenActions from "../../../common/status/screen/actions";
import ScrollToTopOnMount from "../../../common/scrollToTopOnMount/ScrollToTopOnMount";
import { PRIVACY_TITLE } from "../../../constants/title";
import { setHeadDefault } from "../../../constants/sns";

/**
 * プライバシーポリシー画面.
 */
const Privacy = () => {
    /** Hooks. */
    const dispatch = useDispatch();

    /**
     * 画面描画時に実行する処理.
     */
    useEffect(() => {
        dispatch(screenActions.privacy());

        // head設定.
        setHeadDefault(PRIVACY_TITLE);
    }, [dispatch]);

    return (
        <div>
            {/* 遷移時に画面トップに移動. */}
            <ScrollToTopOnMount />
            <Parallax className="l-planetBg rellax" speed={2}></Parallax>
            <div className="l-main">
                <div className="c-static">
                    <div className="c-static__logo"><img src="./assets/images/logo-brand-imagination.png" alt="TSUBURAYA imagination" /></div>
                    <div className="c-static__box">
                        <div className="c-static__boxTop">
                            <div className="c-static__boxTopTtl">プライバシーポリシー</div>
                        </div>
                        <ul className="c-static__wrap">
                            <li className="c-static__item">
                                <div className="c-static__dtl">1.　当社は、本サービスに関連して取得した会員の個人情報その他の会員に関するデータ（メンバーシップ及び、認証識別情報、クッキー、IPアドレス、お問い合わせ内容、本コンテンツの視聴履歴、投稿データ、その他本サービスの利用状況等を含み、以下「会員データ」といいます。）を当社のプライバシーポリシーに定める利用目的の範囲で利用します。<br/><br/>2.　当社は、本サービスの契約又は解約に係る分析、マーケティング及び会員又は本サービス未契約のユーザーに対する広告、今後の新事業への活用のため、会員データのうち識別子、契約プラン、本サイト閲覧履歴、動画視聴履歴、入退会日等を株式会社ＮＴＴドコモ（以下「ドコモ」といいます。）に提供します。<br/><br/>3.　会員が当社にお問い合わせいただいた内容が、ドコモサービス又はドコモと会員間の契約に関する場合、当社は、会員のご指示に基づき会員の同意を得た上で、ドコモに会員データの一部を伝える場合があります。<br/><br/>4.　本サイトではドコモが提供する情報収集モジュールを用い、サイト利用者のアクセス履歴等の情報を収集する場合があります。サイト利用者はそのような情報の収集を希望しない場合、これを停止することができます。詳細については、以下のサイトをご覧ください。<a className="c-static__dtlLink" href="https://www.nttdocomo.co.jp/utility/term/handling_information.html" target="_blank" rel="noreferrer">お客さまが閲覧するwebサイトでのNTTドコモによる情報収集と利用について（NTTドコモ）</a><br/><br/>5.　当社は、本サービス内のコミュニティーサービスにおいて取得した会員データの全部または一部を、コミュニティーサービスの提供及び今後のコミュニティーサービス内での活用のために株式会社Gaudiyに提供します。<br/><br/>6.　本条は、会員データの取扱いのうち本サービスに特有の内容を定めるものです。会員データの取扱いについては、本条の定めのほか、当社が別途定める<a className="c-static__dtlLink" href="https://m-78.jp/privacy/" target="_blank" rel="noreferrer">プライバシーポリシー</a>が適用されます。また、本サイトにより取得する会員データについては<a className="c-static__dtlLink" href="https://m-78.jp/cookie/" target="_blank" rel="noreferrer">「クッキーについて」</a>が適用されます。</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Privacy;
